import { FlagsReadyContext } from 'components/FlagsProvider'
import { useContext } from 'react'

/**
 * Whether LaunchDarkly has evaluated flags for the context we actually want
 * (`merchant-<id>` for a signed-in session), as opposed to the
 * `merchant-logged-out` placeholder it boots with.
 *
 * Gate on this before taking any *irreversible* action on a false flag —
 * redirecting away from a route, most of all. `useFlag` returns
 * `useFlags()[key] ?? defaultValue`, so "flag is off" and "LD has not evaluated
 * this context yet" are the same value, and a redirect fired during the second
 * case cannot be taken back once the real value arrives.
 *
 * Rendering decisions (showing a nav link, enabling a control) do NOT need
 * this — they self-correct when the flag settles.
 */
const useFlagsReady = (): boolean => useContext(FlagsReadyContext)

export default useFlagsReady
